import { typeModelsProject } from "../assets/type_assets";

export const models = [
	{
		id: 0,
		model: typeModelsProject.balataModel,
	},
	{
		id: 1,
		model: typeModelsProject.balataPeque,
	},
	{
		id: 2,
		model: typeModelsProject.disco,
	},
	{
		id: 3,
		model: typeModelsProject.disco2,
	},
];
